import { is } from "ramda";

const transformObjectToDotNotation = (
  object: Record<string, unknown>,
  prefix = ""
): string[] => {
  const result: string[] = [];

  Object.entries(object).forEach(([key, value]) => {
    if (!value) return;
    const nextKey = prefix ? `${prefix}.${key}` : key;
    if (is(Object, value)) {
      result.push(
        ...transformObjectToDotNotation(
          value as Record<string, unknown>,
          nextKey
        )
      );
    } else {
      result.push(nextKey);
    }
  });

  return result;
};

const getErrorFieldName = (
  formikErrors: Record<string, unknown>
): string | undefined => transformObjectToDotNotation(formikErrors)?.[0];

export const getFieldsWithServerError = (
  status: Record<string, unknown> = {}
): string[] =>
  Object.keys(status).filter(
    fieldName => status[fieldName] != null && status[fieldName] !== ""
  );

export const scrollToError = (
  formRef: React.RefObject<HTMLFormElement | null>,
  errors: Record<string, unknown>,
  status: Record<string, unknown>
): void => {
  const fieldErrorName = getErrorFieldName(errors);
  const [fieldWithServerError] = getFieldsWithServerError(status);

  if (!fieldErrorName && !fieldWithServerError) return;

  const errorFieldName = fieldErrorName || fieldWithServerError;
  const errorFormElement = formRef.current?.querySelector(
    `[name="${errorFieldName}"]`
  );

  errorFormElement?.scrollIntoView({
    behavior: "smooth",
    block: "center",
  });
};
